import {
  ADD_POST,
  EDIT_POST
} from "../../actions/types";

const initalizeState = {
  postInView: null,
  loading: true,
  updatedAt: new Date(),
};

export default function (state = initalizeState, action) {
  const { type, payload } = action;
  switch (type) {
    case ADD_POST:
      return {
        ...state,
        postInView: payload,
        loading: false,
        updatedAt: new Date(),
      };
    case EDIT_POST:
      return {
        ...state,
        postInView: payload,
        loading: false,
        updatedAt: new Date(),
      };
    default:
      return state;
  }
}
